import { lazy, Suspense, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./App.scss";
import ProtectedRoutes from "routes/ProtectedRoutes";
import { loginSessionAvailable } from "./features/OnBoarding/authenticationSlice";
const LoginPage = lazy(() => import("features/OnBoarding/LoginPage"));

function App() {
  const dispatch = useDispatch();
  //Getting isAuthenticated store value from Authentication slice.
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const isAuthenticatedState = useSelector(
    (state) => state.authentication.isAuthenticated
  );
  useEffect(() => {
    if (!isAuthenticatedState) {
      var isAuthenticateStorage = localStorage.getItem("isAuthenticated");
      setIsAuthenticated(isAuthenticateStorage);
      if (isAuthenticateStorage) {
        dispatch(loginSessionAvailable());
      } else {
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(isAuthenticatedState);
    }
  }, [isAuthenticatedState, dispatch]);

  return (
    <>
      {isAuthenticated != null && (
        <Router>
          <Suspense fallback={<div>Loading...</div>}>
            <Switch>
              <PublicRoute path="/login" isAuthenticated={isAuthenticated}>
                <LoginPage />
              </PublicRoute>
              <PrivateRoute
                path="/productionmaster"
                isAuthenticated={isAuthenticated}
              >
                <ProtectedRoutes />
              </PrivateRoute>
              <PrivateRoute path="/workorder" isAuthenticated={isAuthenticated}>
                <ProtectedRoutes />
              </PrivateRoute>
              <PrivateRoute path="/dashboard" isAuthenticated={isAuthenticated}>
                <ProtectedRoutes />
              </PrivateRoute>
              <PrivateRoute
                path="/productioncalendar"
                isAuthenticated={isAuthenticated}
              >
                <ProtectedRoutes />
              </PrivateRoute>
              <PrivateRoute path="/reports" isAuthenticated={isAuthenticated}>
                <ProtectedRoutes />
              </PrivateRoute>
              <PrivateRoute
                path="/adddailyupdates"
                isAuthenticated={isAuthenticated}
              >
                <ProtectedRoutes />
              </PrivateRoute>
              <PrivateRoute
                path="/thermometre"
                isAuthenticated={isAuthenticated}
              >
                <ProtectedRoutes />
              </PrivateRoute>
              <PrivateRoute
                path="/finalProduct"
                isAuthenticated={isAuthenticated}
              >
                <ProtectedRoutes />
              </PrivateRoute>
              <PrivateRoute path="/inventory" isAuthenticated={isAuthenticated}>
                <ProtectedRoutes />
              </PrivateRoute>
              <PrivateRoute path="/" isAuthenticated={isAuthenticated}>
                <ProtectedRoutes />
              </PrivateRoute>
            </Switch>
          </Suspense>
        </Router>
      )}
    </>
  );
}

// Private route restrict to access public pages after login.
function PrivateRoute({ children, isAuthenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          rest.path === "/" ? (
            <Redirect
              to={{
                pathname: "/dashboard",
                state: { from: location },
              }}
            />
          ) : (
            children
          )
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

// Public route restrict to access authenticated pages before login.
function PublicRoute({ children, isAuthenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        !isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default App;
